module.exports = __webpack_public_path__ + "img/private-warehouse.a1373f3f.svg";